import React from 'react';
import scrollIntoView from 'scroll-into-view';
import classNames from 'classnames';

function ToolbarButton(_ref) {
  var button = _ref.button,
      editor = _ref.editor,
      _ref$selected = _ref.selected,
      selected = _ref$selected === void 0 ? false : _ref$selected,
      _ref$hover = _ref.hover,
      hover = _ref$hover === void 0 ? false : _ref$hover;
  var buttonRef = React.useRef();
  var active = button.isActive ? button.isActive(editor) : false;
  var onMouseDown = React.useCallback(function (event) {
    return event.preventDefault();
  }, []);
  var onClick = React.useCallback(function () {
    editor.applyToolbarButton();
    return false;
  }, [editor]);
  var onMouseMove = React.useCallback(function () {
    if (!hover) editor.setToolbarHoverButton(button);
  }, [hover, editor, button]);
  React.useLayoutEffect(function () {
    if (selected) {
      scrollIntoView(buttonRef.current, {
        time: 200,
        validTarget: function validTarget(target, parentsScrolled) {
          return target.querySelector && target.querySelector('.slite-editor-toolbar') === null;
        }
      });
    }
  }, [selected]);
  return React.createElement("div", {
    ref: buttonRef,
    "data-toolbar-button": button.id,
    className: classNames('padding-small flexbox flexbox-align-center radius-normal line-height-large pointer', 'shade-10', {
      'background-shade-50': hover
    }),
    onMouseDown: onMouseDown,
    onMouseMove: onMouseMove,
    onClick: onClick
  }, React.createElement("span", {
    className: "margin-right-normal"
  }, React.createElement(button.icon, {
    className: classNames('block', active ? 'primary' : 'shade-30')
  })), React.createElement("span", {
    className: "font-size-normal line-height-one font-weight-medium"
  }, button.title));
}

export default React.memo(ToolbarButton);